var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.crewsList.length > 0)?_c('vca-card',[_c('EventAsp',{ref:"event_asp",model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }